import React from 'react';
import { Props } from '../types';
import { filterProps, slottedToComponents } from '../helpers';

type RedLetterProps = {
  /* eslint-disable @typescript-eslint/naming-convention */
  'description-text': string;
  'download-text': string;
  'expiration-date': number;
  'red-letter-text': string;
  'release-date': number;
  /* eslint-enable @typescript-eslint/naming-convention */
  download: string;
};

export const RocheRedLetter = (
  { blok, getComponent, slot }: Props<RedLetterProps>,
): JSX.Element => {
  const { props, slotted } = filterProps(blok);

  const allProps = {
    ...props,
    ...(slot ? { slot } : {}),
    // eslint-disable-next-line no-underscore-dangle
    ...(blok._uid ? { uid: blok._uid } : {}),
  };

  const releaseDate = blok.release_date ? blok.release_date.replace(/\s+/g, 'T') : null;
  const expirationDate = blok.expiration_date ? blok.expiration_date.replace(/\s+/g, 'T') : null;

  const currentDate = new Date();
  const parsedReleaseDate = new Date(releaseDate);
  const parsedExpirationDate = new Date(expirationDate);

  const isRenderComponent = currentDate >= parsedReleaseDate && currentDate <= parsedExpirationDate;

  return (!blok.expiration_date || isRenderComponent)
    && React.createElement('roche-red-letter',
      {
        ...allProps,
      }, slottedToComponents(getComponent, slotted));
};
